const ThunderFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
  >
    <path
      fill="#437EF7"
      d="m7.686 17.295 7.26-14.52c.055-.11.22-.07.22.053v7.977c0 .413.418.695.8.542l3.61-1.444c.497-.199.978.323.738.803l-7.26 14.519c-.055.11-.22.07-.22-.052v-7.978a.583.583 0 0 0-.8-.541l-3.61 1.443a.583.583 0 0 1-.738-.802Z"
    />
  </svg>
);
export default ThunderFilled;
